import {UserSubjectView} from 'api/gen/UserSubjectView';

import {MemberOfSubjectsTableType} from '../../types/member-of-subjects-table-type';

/**
 * Maps subject-membership API rows into the table representation.
 *
 * @param row Source API row with membership metadata.
 * @returns The table row used by the member-of-subjects tab.
 */
export const rowMapper = (row: UserSubjectView): MemberOfSubjectsTableType => ({
    approvedFrom: row.approvedFrom,
    code: row.code,
    subjectUserProfileId: row.subjectUserProfileId,
    approvedTo: row.approvedTo,
    businessName: row.businessName,
    id: row.subjectUserProfileId,
    subjectId: row.subjectId,
});
